var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotificationSurveyIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 0C27.9411 0 36 8.05876 36 18C36 27.9412 27.9411 36 18 36C8.05889 36 0 27.9412 0 18C0 8.05876 8.05889 0 18 0Z",
    fill: "#41B5C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.238 8.43644V7H13.9078V8.43644H10V29H25.1459V8.43644H21.238ZM15.1986 8.29079H19.9472V9.87283H15.1986V8.29079ZM23.8551 27.7092H11.2908V9.72723H13.9078V11.1636H21.238V9.72723H23.8551V27.7092H23.8551Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2227 16.3715L13.6453 15.6493L12.6371 16.4553L14.2111 18.424L16.6526 15.44L15.6536 14.6226L14.2227 16.3715Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5389 20.2939L14.6181 21.2147L13.6973 20.2939L12.7846 21.2066L13.7054 22.1274L12.7846 23.0482L13.6973 23.9609L14.6181 23.0401L15.5389 23.9609L16.4517 23.0482L15.5309 22.1274L16.4517 21.2066L15.5389 20.2939Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9602 16.1213H22.435V17.4121H17.9602V16.1213Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9602 21.482H22.435V22.7728H17.9602V21.482Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationSurveyIcon);
export default __webpack_public_path__ + "static/media/notification_survey_icon.659499644658b05010219635486579cd.svg";
export { ForwardRef as ReactComponent };